module.exports = __webpack_public_path__ + "static/media/memos_note7.d8718e4b.jpg";